import { put, call } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';

import { fornecedoresAPI } from 'services/apiRest';
import FornecedoresActions from '../ducks/fornecedores';

export function* getFornecedores() {
  try {
    const fornecedores = yield call(fornecedoresAPI.listar);
    yield put(FornecedoresActions.getFornecedoresSuccess(fornecedores));
  } catch (err) {
    console.error('Erro ao buscar fornecedores:', err);
    yield put(FornecedoresActions.getFornecedoresFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao buscar fornecedores',
      })
    );
  }
}

export function* addFornecedor({ fornecedor, closeModal }) {
  try {
    const fornecedorCriado = yield call(fornecedoresAPI.criar, fornecedor);
    yield put(FornecedoresActions.addFornecedorSuccess(fornecedorCriado));
    
    if (closeModal) closeModal();
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Fornecedor',
        message: 'Fornecedor criado com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao criar fornecedor:', err);
    yield put(FornecedoresActions.addFornecedorFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao criar fornecedor',
      })
    );
  }
}

export function* updateFornecedor({ fornecedor, closeModal }) {
  try {
    const fornecedorAtualizado = yield call(
      fornecedoresAPI.atualizar,
      fornecedor.id,
      fornecedor
    );
    yield put(FornecedoresActions.updateFornecedorSuccess(fornecedorAtualizado));
    
    if (closeModal) closeModal();
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Fornecedor',
        message: 'Fornecedor atualizado com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao atualizar fornecedor:', err);
    yield put(FornecedoresActions.updateFornecedorFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao atualizar fornecedor',
      })
    );
  }
}

export function* removeFornecedor({ id }) {
  try {
    yield call(fornecedoresAPI.deletar, id);
    yield put(FornecedoresActions.removeFornecedorSuccess(id));
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Fornecedor',
        message: 'Fornecedor excluído com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao excluir fornecedor:', err);
    yield put(FornecedoresActions.removeFornecedorFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao excluir fornecedor',
      })
    );
  }
}

